import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const MontoImpuestoRetenidoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Impuesto retenido' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='montoImpuestoRetenido'>
          {({ field }) => <Form.InputText {...field} id='input-montoImpuestoRetenido' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoImpuestoRetenidoFormGroup)
